import UserService, {subscribeUser} from "app/Service/ClientUser/UserService"
import SystemModuleNavigationItem, {
  SystemModuleNavigationModule
} from "app/WebController/Component/Nav/SystemModuleNavigationItem"
import ComponentLoader from "app/WebView/Component/Loader/ComponentLoader"
import Logger from "logger/logger"
import React, {useEffect, useState} from "react"
import SystemModuleService, {subscribeSystemModule} from "app/Service/System/Module/SystemModuleService"

function SystemModuleNavigation() {

  const {userEmail, hasRole} = UserService([
    subscribeUser.email
  ], 'ModuleNavigation')

  const {systemModulesFunctional, activeSystemModule} = SystemModuleService([
    subscribeSystemModule.systemModulesFunctional,
    subscribeSystemModule.activeSystemModule,
  ], 'ModuleNavigation')

  const [modules, setModules] = useState<SystemModuleNavigationModule[]>([])

  useEffect(() => {
    Logger('Element.Navigation.Module.init')
    return () => {
      Logger('Element.Navigation.Module.unloading')
    }
  }, [])

  useEffect(function setNavModulesEffect() {
    if (undefined === userEmail) return
    if (systemModulesFunctional.length < 1) return
    const newNavModules: SystemModuleNavigationModule[] = []

    systemModulesFunctional.map(module => {
      if (null === module.permission || hasRole(module.permission)) {
        newNavModules.push({
          ...module,
          icon: '',
          active: module.id === activeSystemModule?.id
        })
      }
    })

    setModules(newNavModules)
  }, [systemModulesFunctional, activeSystemModule, userEmail])

  const NavStyle = {
    display: 'flex',
    flexGrow: 1,
    alignSelf: 'stretch',
    alignItems: 'stretch',
  }

  return (
    <div className={`nav nav--modules`} style={NavStyle} id={`system-nav`}>
      {modules.length < 1 ? (
          <ComponentLoader
            id={'nav-modules'}
            name={'Navigation'}
            inline
          />
        ) :
        modules
        .sort((a, b) => a.order - b.order)
        .map(module => (
          <SystemModuleNavigationItem
            key={module.id}
            module={{...module}}
          />
        ))}
    </div>
  )
}

export default SystemModuleNavigation
